module.exports = __webpack_public_path__ + "static/media/logo-completo.ea0fb4b0.png";